// GENERATED FILE - DO NOT MODIFY
import { EquipmentModel } from "api/models/company/equipment/equipment-model";
import { PagingInfo } from "api/paging-info";
import BaseProxy from "api/proxies/base-proxy";
import ModelDateTransformer from "api/util/model-date-transformer";
import { autoinject } from "aurelia-framework";
import { ApiHelper } from "helpers/api-helper";
import { HttpClientFactory } from "http-client/http-client-factory";
import { HttpClientRequestConfig } from "http-client/http-client-request-config";

@autoinject()
export class DailyEntryLinkEquipmentProxy extends BaseProxy {
    constructor(modelDateTransformer: ModelDateTransformer, httpClientFactory: HttpClientFactory, apiHelper: ApiHelper) {
        super(modelDateTransformer, httpClientFactory, apiHelper);
    }

    public async GetDailyEntryEquipments(dispatchProjectId: string | null, dispatchDate: Date, filter?: string, pagingInfo?: PagingInfo, requestConfig?: HttpClientRequestConfig): Promise<EquipmentModel[] | null> {
        const uri = this.buildUri(
            "/dispatch/projects/{dispatchProjectId}/dispatchdates/{dispatchDate}/equipments",
            { dispatchProjectId: (dispatchProjectId === null || dispatchProjectId === undefined) ? undefined : dispatchProjectId, dispatchDate: (dispatchDate === null || dispatchDate === undefined) ? undefined : dispatchDate.toString() },
            { filter: filter ? filter : undefined, page: (pagingInfo && pagingInfo.page ? pagingInfo.page.toString() : undefined), pagesize: (pagingInfo && pagingInfo.pageSize ? pagingInfo.pageSize.toString() : undefined) }
        );

        const data: EquipmentModel[] | null = await this.get<EquipmentModel[] | null>(uri, requestConfig);
        this.transformModels(data, "Company.Equipment.EquipmentModel");
        return data;
    }

    public async SaveNewDailyEntryLinkEquipment(dispatchId: number, newLinkEquipment: EquipmentModel | null, requestConfig?: HttpClientRequestConfig): Promise<void> {
        const uri = this.buildUri(
            "/dispatch/projects/{dispatchId}/link-equipment",
            { dispatchId: (dispatchId === null || dispatchId === undefined) ? undefined : dispatchId.toString() },
            null
        );

        await this.post<EquipmentModel | null, void>(uri, newLinkEquipment, requestConfig);
    }

    public async DeleteDailyEntryLinkEquipment(dispatchId: number, requestConfig?: HttpClientRequestConfig): Promise<void> {
        const uri = this.buildUri(
            "/dispatch/projects/{dispatchId}/link-equipment",
            { dispatchId: (dispatchId === null || dispatchId === undefined) ? undefined : dispatchId.toString() },
            null
        );

        await this.delete<void>(uri, requestConfig);
    }

    public async GetMustEnterTimeSeparatelyForLinkEquipmentFlagFromDispatch(dispatchId: number, requestConfig?: HttpClientRequestConfig): Promise<boolean> {
        const uri = this.buildUri(
            "/dispatch/projects/{dispatchId}/link-equipment/must-enter-time-separately-for-link-equipment-flag",
            { dispatchId: (dispatchId === null || dispatchId === undefined) ? undefined : dispatchId.toString() },
            null
        );

        const data: boolean = await this.get<boolean>(uri, requestConfig);
        return data;
    }
}
